// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductFullTruckLoad, {
    ProductFullTruckLoadPresentationProps,
} from "@store/Library/Components/ProductFullTruckLoad";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductDetailsFullTruckLoadProps extends WidgetProps {}

export interface ProductDetailsFullTruckLoadStyles {
    productFullTruckLoad?: ProductFullTruckLoadPresentationProps;
}

export const productDetailsFullTruckLoadStyles: ProductDetailsFullTruckLoadStyles = {
    productFullTruckLoad: {
        extendedStyles: {
            ftlWrapper: {
                css: css`
                    margin-bottom: ${pxToRem(8)};
                `,
            },
        },
    },
};

const styles = productDetailsFullTruckLoadStyles;

const ProductDetailsFullTruckLoad: FC<ProductDetailsFullTruckLoadProps> = () => {
    return <ProductFullTruckLoad {...styles.productFullTruckLoad} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsFullTruckLoad,
    definition: {
        group: "Product Details",
        displayName: "Product Details Full Truck Loads",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
